import React, { useState } from 'react';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import './Chatbox.scss';
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  MessageModel,
} from '@chatscope/chat-ui-kit-react';
import { Button } from 'antd';

const initialMessages: MessageModel[] = [
  {
    message: 'Hello! How can I help you?',
    sender: 'Bot',
    direction: 'incoming',
    position: 'single',
  },
];

const PopupChatbox = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState(initialMessages);

  const handleSend = (text: string) => {
    const newMessage: MessageModel = {
      message: text,
      sender: 'User',
      direction: 'outgoing',
      position: 'single',
    };
    setMessages((prev) => [...prev, newMessage]);
  };

  return (
    <div className={`chatbox-wrapper ${isOpen ? 'active' : 'inactive'} hidden`}>
      {!isOpen && (
        <div className="chatbox-open-btn-container">
          <Button
            className="chatbox-open-btn"
            size="large"
            icon="chat"
            onClick={() => setIsOpen(true)}
          />
          <div className="chatbox-unread-msg">32</div>
        </div>
      )}
      {isOpen && (
        <>
          <MainContainer className="chatbox-container">
            <ChatContainer>
              <MessageList>
                {messages.map((msg, i) => (
                  <Message key={i} model={msg} />
                ))}
              </MessageList>
              <MessageInput
                autoFocus
                placeholder="Type message..."
                onSend={handleSend}
              />
            </ChatContainer>
          </MainContainer>
          <Button
            icon="close"
            className="chatbox-close-btn"
            onClick={() => setIsOpen(false)}
          />
        </>
      )}
    </div>
  );
};

export default PopupChatbox;
